// Mock data for Veentto Vagos B2B brutalist clone

export const NAV_ITEMS = [
  { label: 'Mercado', href: '#mercado', num: '01' },
  { label: 'Catálogo', href: '#modelos', num: '03' },
  { label: 'Comparativo', href: '#comparativo', num: '04' },
  { label: 'Tabela', href: '#tabela', num: '05' },
  { label: 'Calculadora', href: '#calculadora', num: '06' },
  { label: 'FAQ', href: '#faq', num: '08' },
  { label: 'Candidatura', href: '#candidatura', num: '09' },
];

export const HERO_STATS = [
  { value: '+537 €', label: 'Margem mín.', sub: 'por unidade' },
  { value: '1 ano', label: 'Garantia bateria', sub: 'sem custos' },
  { value: '100%', label: 'Gama em lítio', sub: 'não vendemos chumbo' },
  { value: '10', label: 'Anos de actividade', sub: 'no mercado português' },
  { value: '2', label: 'Unidades p/ visitar', sub: 'Lisboa & Vagos' },
  { value: 'PT', label: 'Stock em solo PT', sub: 'entrega imediata' },
];

export const MARKET_POINTS = [
  { value: '6 meses', label: 'Garantia média de bateria de chumbo dos concorrentes. Depois disso, é o cliente quem paga.', tone: 'dark' },
  { value: '12 meses', label: 'Garantia da bateria de lítio Veentto Vagos. 1 ano, sem custos adicionais.', tone: 'red' },
  { value: '−60%', label: 'Mais leve que uma bateria de chumbo equivalente. Mais autonomia, mais conforto.', tone: 'yellow' },
];

export const REASONS = [
  { value: '3–5', unit: 'anos', label: 'Vida útil real da bateria de lítio.', vs: 'vs. 12–18 meses do chumbo' },
  { value: '800+', unit: 'ciclos', label: 'Ciclos de carga garantidos.', vs: 'vs. ~250 do chumbo' },
  { value: '3–4', unit: 'horas', label: 'Tempo de carga completo.', vs: 'vs. 6–8 h do chumbo' },
  { value: '0 €', unit: '', label: 'Manutenção periódica da bateria.', vs: 'vs. revisões anuais do chumbo' },
];

export const MODELS = [
  {
    id: 'power',
    sku: 'PWR',
    name: 'Power',
    tagline: 'A gama de entrada.',
    description: 'Equilíbrio perfeito entre preço e prestação para mobilidade urbana diária.',
    pvp: '1 490 €',
    margin: '+537 €',
    image: 'https://www.veenttovagos.com/b2b/images/power-red.webp',
    voltages: ['48V', '60V'],
    capacities: ['20Ah', '24Ah', '30Ah'],
    accent: 'red',
  },
  {
    id: 'nice',
    sku: 'NCE',
    name: 'Nice',
    tagline: 'Linha intermédia, lifestyle.',
    description: 'Acabamentos cuidados para quem procura presença visual.',
    pvp: '1 590 €',
    margin: '+637 €',
    image: 'https://www.veenttovagos.com/b2b/images/nice-vermelha.png',
    voltages: ['48V', '60V'],
    capacities: ['20Ah', '24Ah', '30Ah'],
    accent: 'yellow',
  },
  {
    id: 'briza',
    sku: 'BRZ',
    name: 'Briza',
    tagline: 'Linha desportiva, agressiva.',
    description: 'Mesma plataforma, design diferenciado para o cliente que pede atitude.',
    pvp: '1 590 €',
    margin: '+641 €',
    image: 'https://www.veenttovagos.com/b2b/images/briza-preta.jpg',
    voltages: ['48V', '60V'],
    capacities: ['20Ah', '24Ah', '30Ah'],
    accent: 'black',
  },
];

export const COMPARISON = {
  chumbo: {
    title: 'O que a concorrência ainda vende',
    badge: '× Comparativo chumbo-ácido',
    items: [
      'Bateria de chumbo — pesada, fixa, manutenção periódica',
      '12–18 meses de vida útil real',
      '250 ciclos de carga',
      '6–8 h de carga completa',
      '6 meses de garantia',
      'Peso de referência (+60%)',
      'Sem test drive antes da compra',
    ],
    highlight: '6 meses',
    highlightLabel: 'Tempo até a primeira reclamação',
  },
  litio: {
    title: 'O que vende a Veentto Vagos',
    badge: '● Veentto Vagos · Lítio',
    items: [
      'Lítio em toda a gama — 48V e 60V, 20/24/30 Ah',
      '3–5 anos de vida útil real',
      '800+ ciclos de carga',
      '3–4 h de carga completa',
      '12 meses de garantia da bateria',
      '−60% mais leve',
      'Test drive gratuito em Vagos antes de comprar',
    ],
    highlight: '1 ano',
    highlightLabel: 'Garantia, sem custos extras',
  },
};

export const PRICE_TABLE = [
  { group: 'POWER', rows: [
    { spec: '48V · Power · 20Ah', dealer: '952,20 €', pvp: '1 490,00 €', margin: '+537,80 €', charger: '3 Ah' },
    { spec: '48V · Power · 24Ah', dealer: '980,20 €', pvp: '1 590,00 €', margin: '+609,80 €', charger: '5 Ah' },
    { spec: '48V · Power · 30Ah', dealer: '1 035,00 €', pvp: '1 690,00 €', margin: '+655,00 €', charger: '5 Ah' },
    { spec: '60V · Power · 20Ah', dealer: '997,10 €', pvp: '1 590,00 €', margin: '+592,90 €', charger: '3 Ah' },
    { spec: '60V · Power · 24Ah', dealer: '1 031,34 €', pvp: '1 690,00 €', margin: '+658,66 €', charger: '5 Ah' },
    { spec: '60V · Power · 30Ah', dealer: '1 046,00 €', pvp: '1 790,00 €', margin: '+744,00 €', charger: '5 Ah' },
  ]},
  { group: 'NICE', rows: [
    { spec: '48V · Nice · 20Ah', dealer: '953,00 €', pvp: '1 590,00 €', margin: '+637,00 €', charger: '3 Ah' },
    { spec: '48V · Nice · 24Ah', dealer: '980,80 €', pvp: '1 690,00 €', margin: '+709,20 €', charger: '5 Ah' },
    { spec: '48V · Nice · 30Ah', dealer: '1 036,40 €', pvp: '1 790,00 €', margin: '+753,60 €', charger: '5 Ah' },
    { spec: '60V · Nice · 20Ah', dealer: '997,80 €', pvp: '1 690,00 €', margin: '+692,20 €', charger: '3 Ah' },
    { spec: '60V · Nice · 24Ah', dealer: '1 032,12 €', pvp: '1 790,00 €', margin: '+757,88 €', charger: '5 Ah' },
    { spec: '60V · Nice · 30Ah', dealer: '1 095,60 €', pvp: '1 890,00 €', margin: '+794,40 €', charger: '5 Ah' },
  ]},
  { group: 'BRIZA', rows: [
    { spec: '48V · Briza · 20Ah', dealer: '948,40 €', pvp: '1 590,00 €', margin: '+641,60 €', charger: '3 Ah' },
    { spec: '48V · Briza · 24Ah', dealer: '976,20 €', pvp: '1 690,00 €', margin: '+713,80 €', charger: '5 Ah' },
    { spec: '48V · Briza · 30Ah', dealer: '1 031,80 €', pvp: '1 790,00 €', margin: '+758,20 €', charger: '5 Ah' },
    { spec: '60V · Briza · 20Ah', dealer: '993,28 €', pvp: '1 690,00 €', margin: '+696,72 €', charger: '3 Ah' },
    { spec: '60V · Briza · 24Ah', dealer: '1 027,52 €', pvp: '1 790,00 €', margin: '+762,48 €', charger: '5 Ah' },
    { spec: '60V · Briza · 30Ah', dealer: '1 096,00 €', pvp: '1 890,00 €', margin: '+794,00 €', charger: '5 Ah' },
  ]},
];

// Used by calculator — index by model > voltage > capacity
export const CALC_PRICING = {
  Power: {
    '48V': { '20Ah': { dealer: 952.20, pvp: 1490, margin: 537.80 }, '24Ah': { dealer: 980.20, pvp: 1590, margin: 609.80 }, '30Ah': { dealer: 1035, pvp: 1690, margin: 655 } },
    '60V': { '20Ah': { dealer: 997.10, pvp: 1590, margin: 592.90 }, '24Ah': { dealer: 1031.34, pvp: 1690, margin: 658.66 }, '30Ah': { dealer: 1046, pvp: 1790, margin: 744 } },
  },
  Nice: {
    '48V': { '20Ah': { dealer: 953, pvp: 1590, margin: 637 }, '24Ah': { dealer: 980.80, pvp: 1690, margin: 709.20 }, '30Ah': { dealer: 1036.40, pvp: 1790, margin: 753.60 } },
    '60V': { '20Ah': { dealer: 997.80, pvp: 1690, margin: 692.20 }, '24Ah': { dealer: 1032.12, pvp: 1790, margin: 757.88 }, '30Ah': { dealer: 1095.60, pvp: 1890, margin: 794.40 } },
  },
  Briza: {
    '48V': { '20Ah': { dealer: 948.40, pvp: 1590, margin: 641.60 }, '24Ah': { dealer: 976.20, pvp: 1690, margin: 713.80 }, '30Ah': { dealer: 1031.80, pvp: 1790, margin: 758.20 } },
    '60V': { '20Ah': { dealer: 993.28, pvp: 1690, margin: 696.72 }, '24Ah': { dealer: 1027.52, pvp: 1790, margin: 762.48 }, '30Ah': { dealer: 1096, pvp: 1890, margin: 794 } },
  },
};

export const SALES_ARGS = [
  { num: '01', title: 'É a única scooter 100% lítio em Portugal.', desc: 'Diferencial absoluto. Toda a gama (Power, Nice, Briza) em lítio — não apenas o topo.' },
  { num: '02', title: '1 ano de garantia da bateria.', desc: 'O dobro da garantia média de chumbo. Argumento direto para o cliente que já se queimou com chumbo.' },
  { num: '03', title: '3–5 anos de vida útil real.', desc: 'Versus 12–18 meses do chumbo. Custo total de propriedade muito mais baixo.' },
  { num: '04', title: 'Test drive gratuito em Vagos.', desc: 'O cliente experimenta antes. Reduz objecções e aumenta a taxa de conversão.' },
  { num: '05', title: 'Suporte local em Lisboa e Vagos.', desc: '10 anos de actividade em Portugal. Peças, suporte técnico e formação a uma chamada.' },
  { num: '06', title: 'Margem desde +537 € por unidade.', desc: 'Tabela transparente e estável. Sem surpresas no fecho do mês.' },
];

export const FAQ_ITEMS = [
  { q: 'Qual é o pedido mínimo?', a: 'A quantidade mínima para venda B2B é de 3 unidades. O valor negociado não inclui transporte. A entrega é calculada à parte conforme volume e distância, e também conforme o produto segue na caixa ou montado.' },
  { q: 'Como funciona a garantia?', a: '1 ano na bateria de lítio, com substituição direta caso de falha. Os componentes mecânicos seguem a garantia legal. Reparações fazem-se em Vagos ou via parceiro indicado.' },
  { q: 'Existe exclusividade territorial?', a: 'Sim, por concelho ou região, conforme o volume mínimo acordado. Falamos sobre isto na conversa de candidatura.' },
  { q: 'Têm material de marketing / POS?', a: 'Sim. Fornecemos kits de exposição, fichas técnicas, banners, e materiais digitais. Também damos apoio pontual em campanhas locais.' },
  { q: 'Quais os prazos de entrega?', a: 'Para modelos em stock em Vagos: 3 a 7 dias úteis após confirmação. O transporte não está incluído no valor negociado e é calculado à parte conforme volume e distância. A entrega na caixa tende a ter logística menor; a entrega do produto montado exige mais logística, resultando em maior valor logístico.' },
  { q: 'Têm formação para a equipa de vendas?', a: 'Sim. A formação sobre os produtos pode ser realizada nas lojas de Lisboa, Vagos ou no próprio cliente, mediante disponibilidade de agenda. Quando o treinamento é feito no cliente, pode haver custo de deslocamento.' },
];

export const BUSINESS_TYPES = [
  'Loja de mobilidade urbana',
  'Concessionário motos / scooters',
  'Loja de bicicletas',
  'Aluguer / frota',
  'Outro',
];

export const VOLUMES = [
  '3 a 4 unidades',
  '5 a 9 unidades',
  '10 a 19 unidades',
  '20+ unidades',
];

export const CONTACT = {
  phone: '+351 928 272 818',
  lisbonPhone: '+351 928 274 008',
  email: 'b2b@veenttovagos.com',
  lisbonStoreUrl: 'https://www.veentto.com',
  location: 'Vagos · Aveiro',
  hours: 'Seg–Sex · 09:00–18:00',
  response: 'Em 48h',
};
